let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kI8YJ")).then(() => parcelRequire('3xy6E'));